"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-start;\n    margin: 0;\n    padding: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));
/**
 * Preformatted text - element is displayed in a fixed-width font (usually Courier), and it preserves both spaces and line breaks.
 */


var Pre = styled_components_1["default"].pre(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      padded = _ref.padded;
  return styled_components_1.css(_templateObject2(), padded ? "".concat(theme.spacing.unit * 2, "px") : 0);
});
Pre.displayName = "Pre";
exports["default"] = Pre;